import { writable } from "svelte/store";

function createStore() {
    const { subscribe, set, update } = writable({
        isResetRequested: false
    });

    return {
        subscribe,

        reset() {
            update((state) => ({ ...state, isResetRequested: true }));
        }
    };
}

const store = createStore();

export default store;
